import { render } from "./InlineActionButton.vue?vue&type=template&id=2ff5edbf&scoped=true"
import script from "./InlineActionButton.vue?vue&type=script&lang=js"
export * from "./InlineActionButton.vue?vue&type=script&lang=js"

import "./InlineActionButton.vue?vue&type=style&index=0&id=2ff5edbf&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff5edbf"]])

export default __exports__